import { Box, Drawer } from '@mui/material';

import { ContractSummary } from '@octopus/api';

import {
  Controls,
  DrawerHeader,
} from '../../../../modules/components/drawer/employee/DrawerHeader';
import { useGetEmployeeInfo } from '../../hooks/useGetEmployeeInfo';
import { Aggrements } from '../Aggrements';
import { EmployeeDetailsSkeleton } from '../Skeleton';
import { Vacations } from '../Vacations';

export const EmployeeDrawer = ({
  selectedContract,
  controls,
  open,
  onClose,
}: {
  controls?: Controls;
  selectedContract: ContractSummary | null;
  open: boolean;
  onClose: () => void;
}) => {
  const { contract, contractAccrualPeriods, isLoading } =
    useGetEmployeeInfo(selectedContract);

  return (
    <Drawer elevation={2} anchor="right" open={open} onClose={onClose}>
      {isLoading ? (
        <Box
          width={456}
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          p={5}
        >
          <EmployeeDetailsSkeleton />
        </Box>
      ) : (
        <Box px={5}>
          <Box>
            <DrawerHeader controls={controls} contract={contract.data} />
          </Box>
          <Box width={536}>
            <Box mt={2}>
              <Aggrements contract={contract.data} />

              <Vacations vacations={contractAccrualPeriods.data} />
            </Box>
          </Box>
        </Box>
      )}
    </Drawer>
  );
};
